import React from "react";
import { EDoc, EImg, ELink, ETable, ETd, ETr, IBrand } from "../controls/index";
import { ELabel } from "../controls/Label";
import {
    defaultLocation,
    defaultOrg,
    ISignatureState,
    locations,
    Organization,
    organizations,
    SignatureLocation,
} from "./Models";

const brand: IBrand = {
    fontFamily: "Arial, Helvetica, sans-serif",
    documentFontSize: 10,
    documentLineHeight: 12,
    linkColor: "#2C2C2C",
    fontUnit: "pt",
    fontColor: "#2C2C2C", //"#2C2C2C",
};

interface ISignatureHTMLProps extends ISignatureState {
    isHtml?: boolean;
}
interface SignatureHTMLState {
    org: Organization;
    location: SignatureLocation;
}
class SignatureHTML extends React.Component<
    ISignatureHTMLProps,
    SignatureHTMLState
> {
    constructor(props: ISignatureHTMLProps) {
        super(props);
        this.state = {
            org: defaultOrg,
            location: defaultLocation,
        };
    }

    UNSAFE_componentWillReceiveProps = (nextProps: ISignatureHTMLProps) => {
        if (nextProps.org !== this.props.org) {
            if (!nextProps.org) {
                this.setState({
                    org: defaultOrg,
                });
            } else {
                this.setState({
                    org: organizations[parseInt(nextProps.org)],
                });
            }
        }
        if (nextProps.location !== this.props.location) {
            if (!nextProps.location) {
                this.setState({
                    location: defaultLocation,
                });
            } else {
                this.setState({
                    location: locations[parseInt(nextProps.location)],
                });
            }
        }
    };

    getWebAddress = () => {
        const { org, location } = this.state;
        return org.website;
    };

    formatEmail(): string {
        return this.props.email.trim().toLocaleLowerCase();
    }

    formatName(): string {
        return this.props.fullName.trim().toUpperCase();
    }
    formatPronouns(): string {
        return this.props.pronouns && this.props.pronouns !== "0"
            ? `(${this.props.pronouns.trim()})`
            : "";
    }

    formatPhone(num: string): string {
        return num.trim();
    }

    formatTitle(): string {
        return this.props.jobTitle.trim().toUpperCase();
    }

    renderDocument() {
        const contactMargin = 8;
        const { org, location } = this.state;
        const { workPhone, cellPhone } = this.props;
        console.log("original master");
        return (
            <EDoc Brand={brand}>
                <ETable width={"auto"}>
                    <ETr>
                        <ETd
                            style={{ lineHeight: 1, fontSize: 1 }}
                            height={10}
                        ></ETd>
                    </ETr>
                    <ETr>
                        <ETd>
                            <ETable width={"auto"}>
                                <ETr>
                                    <ETd>
                                        <ELabel size={11}>
                                            {this.formatName()}{" "}
                                        </ELabel>
                                        <ELabel size={9}>
                                            {this.formatPronouns()}
                                        </ELabel>
                                    </ETd>
                                </ETr>
                                <ETr>
                                    <ETd style={{ paddingTop: "5px" }}>
                                        <ELabel size={10} color={org.color}>
                                            {this.formatTitle()}
                                        </ELabel>
                                    </ETd>
                                </ETr>
                            </ETable>
                        </ETd>
                    </ETr>
                    <ETr>
                        <ETd
                            style={{ lineHeight: 1, fontSize: 1 }}
                            height={15}
                        ></ETd>
                    </ETr>
                    <ETr>
                        <ETd>
                            <ELink href={`https://${this.getWebAddress()}`}>
                                <EImg
                                    alt={org.name}
                                    width={213}
                                    height={45}
                                    src={org.logoUrl}
                                />
                            </ELink>
                        </ETd>
                    </ETr>
                    <ETr>
                        <ETd
                            style={{ lineHeight: 1, fontSize: 1 }}
                            height={15}
                        ></ETd>
                    </ETr>
                    <ETr>
                        <ETd>
                            <ETable width={"auto"}>
                                <ETr>
                                    <ETd
                                        style={{
                                            fontSize: 9,
                                            paddingRight: contactMargin,
                                            color: org.color,
                                        }}
                                    >
                                        <ELabel size={9} color={org.color}>
                                            E
                                        </ELabel>
                                    </ETd>
                                    <ETd colSpan={3} style={{ fontSize: 10 }}>
                                        <ELink
                                            href={`mailto:${this.formatEmail()}`}
                                        >
                                            {this.formatEmail()}
                                        </ELink>
                                    </ETd>
                                </ETr>
                                <ETr>
                                    <ETd
                                        style={{
                                            paddingRight: contactMargin,
                                            color: org.color,
                                            fontSize: 9,
                                        }}
                                    >
                                        <ELabel size={9} color={org.color}>
                                            T
                                        </ELabel>
                                    </ETd>
                                    <ETd style={{ fontSize: 10 }}>
                                        <ELink
                                            href={`tel:${this.formatPhone(
                                                workPhone
                                            )}`}
                                        >
                                            {this.formatPhone(workPhone)}
                                        </ELink>
                                    </ETd>

                                    <ETd
                                        style={{
                                            paddingRight: contactMargin,
                                            paddingLeft: contactMargin,
                                            color: org.color,
                                            fontSize: 9,
                                        }}
                                    >
                                        {cellPhone.length > 0 && (
                                            <ELabel size={9} color={org.color}>
                                                C
                                            </ELabel>
                                        )}
                                    </ETd>

                                    <ETd style={{ fontSize: 10 }}>
                                        {cellPhone.length > 0 && (
                                            <ELink
                                                href={`tel:${this.formatPhone(
                                                    cellPhone
                                                )}`}
                                            >
                                                {this.formatPhone(cellPhone)}
                                            </ELink>
                                        )}
                                    </ETd>
                                </ETr>
                                <ETr>
                                    <ETd
                                        style={{
                                            paddingRight: contactMargin,
                                            color: org.color,
                                        }}
                                    >
                                        <ELabel size={9} color={org.color}>
                                            W
                                        </ELabel>
                                    </ETd>
                                    <ETd colSpan={3} style={{ fontSize: 10 }}>
                                        <ELink
                                            href={`https://${this.getWebAddress()}`}
                                        >
                                            {this.getWebAddress()}
                                        </ELink>
                                    </ETd>
                                </ETr>
                            </ETable>
                        </ETd>
                    </ETr>
                    {location && location.addressLine1 && (
                        <ETr>
                            <ETd style={{ paddingTop: 20, fontSize: 12 }}>
                                <ELabel break={true}>
                                    {location.addressLine1}
                                </ELabel>
                                <ELabel>{location.addressLine2}</ELabel>
                            </ETd>
                        </ETr>
                    )}
                    {org.hasLegalDisclaimer && (
                        <ETr>
                            <ETd style={{ paddingTop: 20, fontSize: 10 }}>
                                <ELabel break={true}>
                                    This email message, including any
                                    attachments, is for the sole use of the
                                    intended recipient(s) and may contain
                                    information that is confidential and
                                    protected by law from unauthorized
                                    disclosure. Any unauthorized review, use,
                                    disclosure, or distribution is prohibited.
                                    If you are not the intended recipient,
                                    please contact the sender by reply email and
                                    destroy all copies of the original message.
                                </ELabel>
                            </ETd>
                        </ETr>
                    )}
                    <ETr>
                        <ETd style={{ paddingTop: 10 }}>
                            <ELabel break={true}>-</ELabel>
                        </ETd>
                    </ETr>
                </ETable>
            </EDoc>
        );
    }

    render() {
        return this.renderDocument();
    }
}

export default SignatureHTML;
